// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"A8-z"};